'use client';

import { useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { Button } from '@/shared/components/primitives/button';

// Error boundary body for every page under the root layouts: a render error (e.g. a
// BigCommerceGraphqlError) shows a generic, retryable 500 instead of an unstyled crash page.
export function RouteError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations('Error');

  useEffect(() => {
    console.error('[route] render error', error);
  }, [error]);

  return (
    <div className='mx-auto flex max-w-3xl flex-col items-center gap-6 px-8 py-16 text-center'>
      <div className='space-y-2'>
        <h1 className='text-2xl font-bold'>{t('title')}</h1>
        <p>{t('description')}</p>
      </div>
      <div className='flex items-center gap-4'>
        <Button variant='primary' onClick={() => reset()}>
          {t('tryAgain')}
        </Button>
        <Button variant='secondary' href='/'>
          {t('goHome')}
        </Button>
      </div>
    </div>
  );
}
